import React from 'react';
import LeftRight from "../../components/ui/LeftRight";
import s1 from "../../assets/images/products/pages/paperless/1.png";
import s2 from "../../assets/images/products/pages/paperless/2.png";
import s3 from "../../assets/images/products/pages/paperless/3.png";
import s4 from "../../assets/images/products/pages/paperless/4.png";
import {paperlessBoardMeetingMeta} from "../../constants/meta";
import Meta from "../../components/common/Helmet";
import {useTranslation} from "react-i18next";

const PaperlessBoardMeeting = () => {
  const { t } = useTranslation();
  return (
    <div>
      <Meta
        title={paperlessBoardMeetingMeta.title}
        description={paperlessBoardMeetingMeta.description}
        canonical={paperlessBoardMeetingMeta.canonical}
        keywords={paperlessBoardMeetingMeta.keywords}
        ogTitle={paperlessBoardMeetingMeta.title}
        ogDescription={paperlessBoardMeetingMeta.description}
      />
      <div className="md:w-theme-container w-mobile-container mx-auto">
        <div className="my-12">
          <LeftRight
            title={t('paperlessRoomPage.paperlessMeetings')}
            isLeft={false}
            textPosition={'justify-between'}
            textWidthClass={'md:w-1/2'}
            descriptionPosition={'text-left'}
            subtitle={t('paperlessRoomPage.platformSupport')}
            descriptionList={[
              t('paperlessRoomPage.ourCommitment')
            ]}
            icon={false}
            image={s1}
            downloadBtn={true}
            downloadLink={require("../../assets/uploads/pdf/paperless-board-meeting.pdf")}
          />
          <ul className="list-disc list-inside">
            <li key={1} className="text-gray-700 text-lg mb-3">
              {t('paperlessRoomPage.strongSecurity')}
            </li>
            <li key={2} className="text-gray-700 text-lg mb-3">
              {t('paperlessRoomPage.omniPlatform')}
            </li>
            <li key={3} className="text-gray-700 text-lg mb-3">
              {t('paperlessRoomPage.richMeetingTools')}
            </li>
            <li key={4} className="text-gray-700 text-lg mb-3">
              {t('paperlessRoomPage.fileFormatSupport')}
            </li>
            <li key={5} className="text-gray-700 text-lg mb-3">
              {t('paperlessRoomPage.userExperience')}
            </li>
            <li key={6} className="text-gray-700 text-lg">
              {t('paperlessRoomPage.trackRecord')}
            </li>
          </ul>
        </div>
        <div className="mt-24">
          <LeftRight
            title={t('paperlessRoomPage.instantAccess')}
            isLeft={true}
            textWidthClass={'md:w-3/5'}
            textPosition={'justify-center'}
            descriptionPosition={'text-left'}
            subtitle={t('paperlessRoomPage.paperlessBM')}
            descriptionList={[
              t('paperlessRoomPage.paperlessSolution'),
              t('paperlessRoomPage.notifications'),
              t('paperlessRoomPage.annotations'),
              t('paperlessRoomPage.synchronizedView'),
              t('paperlessRoomPage.remoteMeetings'),
              t('paperlessRoomPage.offlineReading'),
            ]}
            icon={true}
            image={s3}
          />
        </div>
        <div className="my-12">
          <LeftRight
            title={t('paperlessRoomPage.saveTime')}
            isLeft={false}
            textWidthClass={'md:w-3/5'}
            textPosition={'justify-center'}
            descriptionPosition={'text-left'}
            subtitle={t('paperlessRoomPage.adminPortal')}
            descriptionList={[
              t('paperlessRoomPage.automateBoardBooks'),
              t('paperlessRoomPage.dragAndDrop'),
              t('paperlessRoomPage.roleBasedAccess'),
              t('paperlessRoomPage.centralRepository'),
              t('paperlessRoomPage.sharepointAccess'),
            ]}
            icon={true}
            image={s2}
          />
        </div>
      </div>
      <div className="bg-[#08141A]">
        <div className="md:w-theme-container w-mobile-container mx-auto py-12">
          <div className="">
            <LeftRight
              title={t('paperlessRoomPage.enterpriseSecurity')}
              titleClass={`text-white`}
              isLeft={true}
              textWidthClass={'md:w-3/5'}
              textPosition={'justify-center'}
              descriptionPosition={'text-left text-white'}
              subtitle={t('paperlessRoomPage.trustedBy')}
              descriptionList={[
                t('paperlessRoomPage.aesEncryption'),
                t('paperlessRoomPage.sslEncryption'),
                t('paperlessRoomPage.isoHosting'),
                t('paperlessRoomPage.onTheFlyDecryption'),
                t('paperlessRoomPage.devicePurge'),
                t('paperlessRoomPage.auditLogging'),
                t('paperlessRoomPage.accessControl'),
              ]}
              icon={true}
              image={s4}
            />
          </div>
        </div>
      </div>
    </div>
  );
};

export default PaperlessBoardMeeting;
